import { useMutation } from '@tanstack/react-query'
import useCycleApi from 'common/hooks/useCycleApi'
import { useGetPonds } from 'modules/pond/api/queries'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { TOPUP_REQUEST_CONFIG } from '.'
import { useGetShrimpTopup, useGetShrimpTopupSummary } from './queries'
import { CreateTopupVariables, EditTopupVariables } from './types'

export const useMutateCreateShrimpTopup = () => {
  const cycleApi = useCycleApi()
  const { enqueueSnackbar } = useSnackbar()
  const { refetch } = useGetShrimpTopup()
  const { refetch: refetchSummary } = useGetShrimpTopupSummary()
  const { refetch: refetchPonds } = useGetPonds()
  const { t } = useTranslation(['common'])

  return useMutation(
    (data: CreateTopupVariables) => cycleApi.request({ ...TOPUP_REQUEST_CONFIG.create, data }),
    {
      onSuccess: () => {
        enqueueSnackbar(t('common:create.success'), { variant: 'success' })
        refetch()
        refetchSummary()
        refetchPonds()
      },
    }
  )
}

export const useMutateDeleteShrimpTopup = () => {
  const cycleApi = useCycleApi()
  const { enqueueSnackbar } = useSnackbar()
  const { refetch } = useGetShrimpTopup()
  const { refetch: refetchSummary } = useGetShrimpTopupSummary()
  const { refetch: refetchPonds } = useGetPonds()
  const { t } = useTranslation(['common'])

  return useMutation(
    (shrimpTopupId: string) =>
      cycleApi.request({
        ...TOPUP_REQUEST_CONFIG.delete,
        url: `${TOPUP_REQUEST_CONFIG.delete.url}/${shrimpTopupId}`,
      }),
    {
      onSuccess: () => {
        enqueueSnackbar(t('common:delete.success'), { variant: 'success' })
        refetch()
        refetchSummary()
        refetchPonds()
      },
    }
  )
}

export const useMutateUpdateShrimpTopup = () => {
  const cycleApi = useCycleApi()
  const { enqueueSnackbar } = useSnackbar()
  const { refetch } = useGetShrimpTopup()
  const { refetch: refetchSummary } = useGetShrimpTopupSummary()
  const { t } = useTranslation(['common'])
  const { refetch: refetchPonds } = useGetPonds()

  return useMutation(
    ({ shrimpTopupId, body }: EditTopupVariables) =>
      cycleApi.request({
        ...TOPUP_REQUEST_CONFIG.edit,
        url: `${TOPUP_REQUEST_CONFIG.edit.url}/${shrimpTopupId}`,
        data: body,
      }),
    {
      onSuccess: () => {
        enqueueSnackbar(t('common:edit.success'), { variant: 'success' })
        refetch()
        refetchSummary()
        refetchPonds()
      },
    }
  )
}
